import { createSlice } from '@reduxjs/toolkit';

const AuthSlice = createSlice({
  name: 'AuthSlice',
  initialState: {
    isLoading: false,
    loginToken: JSON.parse(localStorage.getItem('revive_admin__token')) ?? null,
    adminDetails: [],
    fieldValidationError: null,
    isError: null,
    isEditProfileLoading: false,
  },
  reducers: {
    /////// Login start //////
    requestLogin: (state) => {
      return { ...state, isLoading: true };
    },
    responseLogin: (state, action) => {
      localStorage.setItem(
        'revive_admin__token',
        JSON.stringify(action?.payload?.data?.token),
      );
      return {
        ...state,
        isLoading: false,
        adminDetails: action?.payload?.data?.user,
        loginToken: action?.payload?.data?.token,
        isCompanyLogin: action?.payload?.data?.user?.role,
        fieldValidationError: null,
      };
    },
    failureLogin: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action.payload,
        fieldValidationError: action?.payload,
      };
    },

    /////// Forgot Password //////
    requestForgotPassword: (state) => {
      return { ...state, isLoading: true };
    },
    responseForgotPassword: (state) => {
      return {
        ...state,
        isLoading: false,
        fieldValidationError: null,
      };
    },
    failureForgotPassword: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    /////// Reset Password //////
    requestResetPassword: (state) => {
      return { ...state, isLoading: true };
    },
    responseResetPassword: (state) => {
      return {
        ...state,
        isLoading: false,
        fieldValidationError: null,
      };
    },
    failureResetPassword: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
        fieldValidationError: action?.payload,
      };
    },

    //////// Update Profile ///////
    requestUpdateProfile: (state) => {
      return { ...state, isLoading: true };
    },
    responseUpdateProfile: (state, action) => {
      return {
        ...state,
        isLoading: false,
        adminDetails: action?.payload?.data,
      };
    },
    failureUpdateProfile: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    ////// Edit Profile Data //////
    requestEditProfile: (state) => {
      return { ...state, isEditProfileLoading: true };
    },
    responseEditProfile: (state, action) => {
      return {
        ...state,
        isEditProfileLoading: false,
        adminDetails: action?.payload?.data,
      };
    },
    failureEditProfile: (state, action) => {
      return {
        ...state,
        isEditProfileLoading: false,
        isError: action?.payload,
      };
    },

    ////// logout //////
    requestLogout: (state) => {
      return { ...state, isLoading: true };
    },
    responseLogout: (state, action) => {
      localStorage.removeItem('revive_admin__token');
      localStorage.removeItem('adminData');
      localStorage.removeItem('currentPage');
      return {
        ...state,
        isLoading: false,
        logoutData: action?.payload,
        loginToken: null,
        adminDetails: null,
        fieldValidationError: null,
      };
    },
    failureLogout: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase('update', (state, action) => {
  //     localStorage.setItem('adminData', JSON.stringify(action?.response?.data));
  //     return {
  //       ...state,
  //       adminDetails: action?.response?.data,
  //     };
  //   });
  // },
});

export const {
  requestLogin,
  responseLogin,
  failureLogin,
  requestLogout,
  responseLogout,
  failureLogout,
  failureUpdateProfile,
  requestUpdateProfile,
  responseUpdateProfile,
  failureForgotPassword,
  requestForgotPassword,
  responseForgotPassword,
  failureResetPassword,
  requestResetPassword,
  responseResetPassword,
  failureEditProfile,
  requestEditProfile,
  responseEditProfile,
} = AuthSlice.actions;
export default AuthSlice.reducer;
